$(document).ready(function () {
    $("#ackapa").click(function () {
        $(".trwpwhatsappballon").toggle(100);
    });
    $("#kapatac").click(function () {
        $(".trwpwhatsappballon").toggle(100);
    });
});